module.exports = __webpack_public_path__ + "assets/e5484097ba677767b81f8f21f1f49ae0.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/12/ScatterOrchHit01.mp3
 ** module id = 459
 ** module chunks = 0
 **/